import React from "react";

import { CaddyCartIcon } from "./CaddyCartIcon";
import { CaddyIcon } from "./CaddyIcon";
import { CartIcon } from "./CartIcon";
import { FullCartIcon } from "./FullCartIcon";
import { MotorizedPullCartIcon } from "./MotorizedPullCartIcon";
import { PrivateCartIcon } from "./PrivateCartIcon";
import { PullCartIcon } from "./PullCartIcon";
import { SingleCartIcon } from "./SingleCartIcon";
import { WalkingIcon } from "./WalkingIcon";

export type TransportationCode =
  | "CADDIE"
  | "CADDIE_CART"
  | "CART"
  | "FULL_CART"
  | "MOTOR_PULL_CART"
  | "PRIVATE_CART"
  | "PULL_CART"
  | "SINGLE_CART"
  | "WALK";

export const TeeSheetTransportationIcon = ({
  transportationType,
}: {
  transportationType: TransportationCode;
}) => {
  switch (transportationType) {
    case "CART":
      return <CartIcon />;
    case "CADDIE":
      return <CaddyIcon />;
    case "CADDIE_CART":
      return <CaddyCartIcon />;
    case "MOTOR_PULL_CART":
      return <MotorizedPullCartIcon />;
    case "FULL_CART":
      return <FullCartIcon />;
    case "PRIVATE_CART":
      return <PrivateCartIcon />;
    case "PULL_CART":
      return <PullCartIcon />;
    case "SINGLE_CART":
      return <SingleCartIcon />;
    case "WALK":
    default:
      return <WalkingIcon />;
  }
};
